// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"226":"web3-provider","875":"web3modal"}[chunkId] || chunkId) + "." + {"226":"9bfd8ca7","787":"08ba7eff","875":"b550afff","948":"08474e0e"}[chunkId] + ".chunk.js";
};